
import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { SEO } from '../components/Shared';

const Certificate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name') || 'Arctic Explorer';
  const date = new Date().toLocaleDateString('fi-FI');
  const certId = `AS-${Math.random().toString(36).substring(2, 8).toUpperCase()}`;

  return (
    <div className="max-w-4xl mx-auto px-4 py-20 print:p-0">
      <SEO title="Sertifikaatti | Lapland AI Lab" description="Arctic Security Master Certification" />
      
      <div className="glass-certificate p-1 border-8 border-slate-900 rounded-[4rem] shadow-2xl relative bg-slate-950">
        <div className="p-16 border-2 border-emerald-500/20 rounded-[3.5rem] bg-slate-950 relative overflow-hidden">
          {/* Watermark decorations */}
          <div className="absolute -top-40 -left-40 w-80 h-80 bg-emerald-500/5 rounded-full blur-[100px]"></div>
          <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-blue-500/5 rounded-full blur-[100px]"></div>

          <div className="text-center relative z-10">
            <div className="w-20 h-20 bg-emerald-500 rounded-3xl mx-auto flex items-center justify-center mb-10 shadow-2xl shadow-emerald-500/30 transform rotate-3">
              <svg className="w-12 h-12 text-slate-950" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>

            <h1 className="text-sm font-black text-emerald-400 uppercase tracking-[0.5em] mb-4">Lapland AI Lab</h1>
            <h2 className="text-5xl font-black text-white tracking-tighter uppercase mb-12">Arctic Security <br/>Certification</h2>
            
            <p className="text-slate-500 font-bold uppercase tracking-widest text-[10px] mb-2">Tämä sertifikaatti myönnetään henkilölle</p>
            <div className="text-4xl font-black text-white mb-12 aurora-text inline-block px-4 py-2">{name}</div>
            
            <p className="text-slate-400 max-w-lg mx-auto leading-relaxed mb-16 text-sm">
              Osoitetusta asiantuntijuudesta kyberturvallisuuden, tekoälyriskien hallinnan sekä organisaation digitaalisen resilienssin osa-alueilla.
            </p>

            <div className="grid grid-cols-2 gap-12 border-t border-slate-900 pt-12">
              <div className="text-left">
                <p className="text-[10px] font-black text-slate-600 uppercase tracking-widest mb-1">Myöntöpäivä</p>
                <p className="text-white font-bold">{date}</p>
              </div>
              <div className="text-right">
                <p className="text-[10px] font-black text-slate-600 uppercase tracking-widest mb-1">ID-tunniste</p>
                <p className="text-emerald-500 font-mono font-bold">{certId}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 flex justify-center gap-6 print:hidden">
        <button 
          onClick={() => window.print()}
          className="bg-emerald-500 text-slate-950 px-10 py-5 rounded-2xl font-black uppercase tracking-widest shadow-xl shadow-emerald-500/20"
        >
          Lataa PDF
        </button>
        <Link 
          to="/"
          className="bg-slate-800 text-white px-10 py-5 rounded-2xl font-black uppercase tracking-widest"
        >
          Palaa portaaliin
        </Link>
      </div>
    </div>
  );
};

export default Certificate;
